import React from "react";
import { Dialog, Button } from "@mui/material";
import { Translate } from "orion-components/i18n";

const ConfirmEvacuationDialog = ({ confirmReset, handleEvacuationToggle, setConfirmReset }) => {
	return (
		<Dialog open={confirmReset} PaperProps={{ className: "confirm-evacuation-dialog" }}>
			<div className="section1">
				<div className="section1Child1">
					<div className="section1Child2">
						<div className="section1Child3">
							<Translate value="global.sharedComponents.evacuationAccountability.components.confirmEvacuationDialog.title" />
						</div>
						<div className="section1Child4">
							<Translate value="global.sharedComponents.evacuationAccountability.components.confirmEvacuationDialog.message" />
						</div>
					</div>

					<div className="section2">
						<Button className="section2Child1" onClick={() => setConfirmReset(false)}>
							<Translate value="global.sharedComponents.evacuationAccountability.components.confirmEvacuationDialog.cancel" />
						</Button>
						<Button className="section2Child2" onClick={handleEvacuationToggle}>
							<Translate value="global.sharedComponents.evacuationAccountability.components.confirmEvacuationDialog.confirm" />
						</Button>
					</div>
				</div>
			</div>
		</Dialog>
	);
};

export default ConfirmEvacuationDialog;
